import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
	state: false,
	objState : false,
	processState : false,
	vtstate : false,
	vmstate : false,
	imstate : false,
	vpcstate : false,
	bmstate : false,
	ovtstate : false,
	iptstate : false,
	iistate : false, //Indexed Imagery
	oustate : false, //output unity
	dhstate : false, //Drill Hole
	gcstate : false, //Geo Chem
	objName : '',
	objType : '',
	objSources : [],
	totalFileSize : 0,
	cumulFileSize : 0,
	currentFileSize : 0,
    project : 0,
	options: {
		children: null
	},
	automaticObject: null,
	addOjectState: false,
	addProcessState: false,
};
const viewObjects = createSlice({
	name: 'viewObject',
	initialState: initialState,
	reducers: {
		openObjectDialog :  (state: any, action: PayloadAction<any>) => {
			state.objState = true;
			state.project = action.payload.project;
		},
		closeObjectDialog :  (state: any, action: PayloadAction<any>) => {
			state.objState = false;
			state.options = action.payload;
			state.automaticObject = null;
			//state.automaticProcess = null;
			//state.addOjectState = false;
		},
		openDialog: (state: any, action: PayloadAction<any>) => {
			state.state = true;
			state.objName = action.payload.objName;
		},
		closeDialog: (state: any, action: PayloadAction<any>) => {
			state.state = false;
			state.options = action.payload;
			state.automaticObject = null;
			state.automaticProcess = null;
			state.addOjectState = false;
		},
		openVoxelTerrainDialog: (state: any, action: PayloadAction<any>) => {
			state.vtstate = true;
			state.objName = action.payload.objName;
			state.objType = action.payload.objType;
			state.objSources = action.payload.objSources;
		},
		closeVoxelTerrainDialog: (state: any, action: PayloadAction<any>) => {
			state.vtstate = false;
			state.options = action.payload;
			state.automaticObject = null;
			state.automaticProcess = null;
			state.addOjectState = false;
		},
		openVoxelizedMeshDialog: (state: any, action: PayloadAction<any>) => {
			state.vmstate = true;
			state.objName = action.payload.objName;
			state.objType = action.payload.objType;
			state.objSources = action.payload.objSources;
		},
		closeVoxelizedMeshDialog: (state: any, action: PayloadAction<any>) => {
			state.vmstate = false;
			state.options = action.payload;
			state.automaticObject = null;
			state.automaticProcess = null;
			state.addOjectState = false;
		},
		openIndexedMeshDialog: (state: any, action: PayloadAction<any>) => {
			state.imstate = true;
			state.objName = action.payload.objName;
			state.objType = action.payload.objType;
			state.objSources = action.payload.objSources;
		},
		closeIndexedMeshDialog: (state: any, action: PayloadAction<any>) => {
			state.imstate = false;
			state.options = action.payload;
			state.automaticObject = null;
			state.automaticProcess = null;
			state.addOjectState = false;
		},
		openVoxelBlockModelDialog: (state: any, action: PayloadAction<any>) => {
			state.bmstate = true;
			state.objName = action.payload.objName;
			state.objType = action.payload.objType;
			state.objSources = action.payload.objSources;
		},
		closeVoxelBlockModelDialog: (state: any, action: PayloadAction<any>) => {
			state.bmstate = false;
			state.options = action.payload;
			state.automaticObject = null;
			state.automaticProcess = null;
			state.addOjectState = false;
		},
		openVoxelPointCloudDialog: (state: any, action: PayloadAction<any>) => {
			state.vpcstate = true;
			state.objName = action.payload.objName;
			state.objType = action.payload.objType;
			state.objSources = action.payload.objSources;
		},
		closeVoxelPointCloudDialog: (state: any, action: PayloadAction<any>) => {
			state.vpcstate = false;
			state.options = action.payload;
			state.automaticObject = null;
			state.automaticProcess = null;
			state.addOjectState = false;
		},
		openOrthoVoxelTerrainDialog: (state: any, action: PayloadAction<any>) => {
			state.ovtstate = true;
			state.objName = action.payload.objName;
			state.objType = action.payload.objType;
			state.objSources = action.payload.objSources;
		},
		closeOrthoVoxelTerrainDialog: (state: any, action: PayloadAction<any>) => {
			state.ovtstate = false;
			state.options = action.payload;
			state.automaticObject = null;
			state.automaticProcess = null;
			state.addOjectState = false;
		},
		openIndexedPointDialog: (state: any, action: PayloadAction<any>) => {
			state.iptstate = true;
			state.objName = action.payload.objName;
			state.objType = action.payload.objType;
			state.objSources = action.payload.objSources;
		},
		openDrillHoleDatabaseDialog: (state: any, action: PayloadAction<any>) => {
			state.dhstate = true;
			state.objName = action.payload.objName;
			state.objType = action.payload.objType;
			state.objSources = action.payload.objSources;
		},
		openGeoChemDialog: (state: any, action: PayloadAction<any>) => {
			state.gcstate = true;
			state.objName = action.payload.objName;
			state.objType = action.payload.objType;
			state.objSources = action.payload.objSources;
		},
		closeIndexedPointDialog: (state: any, action: PayloadAction<any>) => {
			state.iptstate = false;
			state.options = action.payload;
			state.automaticObject = null;
			state.automaticProcess = null;
			state.addOjectState = false;
		},
		closeDrillHoleDatabaseDialog: (state: any, action: PayloadAction<any>) => {
			state.dhstate = false;
			state.options = action.payload;
			state.automaticObject = null;
			state.automaticProcess = null;
			state.addOjectState = false;
		},
		closeGeoChemDialog: (state: any, action: PayloadAction<any>) => {
			state.gcstate = false;
			state.options = action.payload;
			state.automaticObject = null;
			state.automaticProcess = null;
			state.addOjectState = false;
		},
		openProcessDialog: (state: any, action: PayloadAction<any>) => {
			state.processState = true;
			state.objName = action.payload.objName;
			state.objType = action.payload.objType;
			state.objSources = action.payload.objSources;
		},
		closeProcessDialog: (state: any, action: PayloadAction<any>) => {
			state.processState = false;
			state.objName = action.payload.objName;
			state.automaticObject = null;
			state.automaticProcess = null;
			state.addOjectState = false;
		},
		openOutputUnityDialog: (state: any, action: PayloadAction<any>) => {
			state.oustate = true;
			state.objName = action.payload.objName;
		},
		closeOutputUnityDialog: (state: any, action: PayloadAction<any>) => {
			state.oustate = false;
			state.objName = action.payload.objName;
			state.automaticObject = null;
			state.automaticProcess = null;
			state.addOjectState = false;
		},
		openIndexedImageryDialog: (state: any, action: PayloadAction<any>) => {
			state.iistate = true;
			state.objName = action.payload.objName;
			state.objType = action.payload.objType;
			state.objSources = action.payload.objSources;
		},
		closeIndexedImageryDialog: (state: any, action: PayloadAction<any>) => {
			state.iistate = false;
			state.objName = action.payload.objName;
			state.automaticObject = null;
			state.automaticProcess = null;
			state.addOjectState = false;
		},
		setProject: (state: any, action: PayloadAction<any>) => {
			state.project = action.payload;
		},
		setTotalFileSize: (state: any, action: PayloadAction<any>) => {
			state.totalFileSize = action.payload
		},
		setCumulFileSize: (state: any, action: PayloadAction<any>) => {
			state.cumulFileSize += action.payload
		},
		setCurrentFileSize: (state: any, action: PayloadAction<any>) => {
			state.currentFileSize = action.payload
		},
		addAutomaticObject: (state: any, action: PayloadAction<any>) => {
			state.automaticObject = action.payload.objName;
			state.project = action.payload.project;
		},
		resetAutomaticObject: (state: any, action: PayloadAction<any>) => {
			state.automaticObject = null
		},
		addAutomaticProcess: (state: any, action: PayloadAction<any>) => {
			state.automaticProcess = action.payload.objName;
			state.project = action.payload.project;
		},
		resetAutomaticProcess: (state: any, action: PayloadAction<any>) => {
			state.automaticProcess = null
		},
		setAddObjectState: (state: any, action: PayloadAction<any>) => {
			state.state = false;
			state.objState = false;
			state.addOjectState = action.payload;
		},
		setAddProcessState: (state: any, action: PayloadAction<any>) => {
			state.addProcessState = action.payload;
		}
	}
});

export const { 
	openDialog, 
	closeDialog, 
	openProcessDialog, 
	closeProcessDialog, 
	openVoxelTerrainDialog, 
	closeVoxelTerrainDialog, 
	openOrthoVoxelTerrainDialog, 
	closeOrthoVoxelTerrainDialog, 
	openIndexedPointDialog, 
	closeIndexedPointDialog,
	closeDrillHoleDatabaseDialog, 
	openVoxelizedMeshDialog,
	closeVoxelizedMeshDialog,
	openIndexedMeshDialog,
	closeIndexedMeshDialog,
	openVoxelBlockModelDialog,
	closeVoxelBlockModelDialog,
	openVoxelPointCloudDialog,
	openDrillHoleDatabaseDialog,
	openGeoChemDialog,
	closeGeoChemDialog,
	closeVoxelPointCloudDialog,
	openOutputUnityDialog,
	closeOutputUnityDialog,
	setProject, 
	openObjectDialog, 
	closeObjectDialog, 
	setTotalFileSize, 
	setCumulFileSize, 
	setCurrentFileSize,
	openIndexedImageryDialog,
	closeIndexedImageryDialog,
	addAutomaticObject,
	resetAutomaticObject,
	setAddObjectState,
	setAddProcessState,
	addAutomaticProcess
 } = viewObjects.actions;

export default viewObjects.reducer;
